<template>
    <div class="prosperity">
        <div class="title-bar">
            <strong style="font-size: .36rem;">修改密码</strong>
        </div>
        <div style="text-align: center;">
            <img src="//images.jinku.com/newjk/org/images/personal/alter_03.png" alt="" style="width: 1.47rem;height: 1.05rem;margin-top: 1.2rem;">
            <p style="margin-top: .45rem;font-size: .28rem;color: black;font-weight: bold;">密码修改成功，请重新登录</p>
        </div>
    </div>
</template>

<script>
    import http from "../../lib/http";

    export default{
        name:'prosperity',
        data(){
            return{

            }
        },
        methods:{
            toLogin:function () {
                const self = this;
                http({
                    method: "post",
                    url: "/user/logout",
                    data: ""
                }).then(function(res){
                    self.$router.push('/login');
                }).catch(function(err){

                });
            }
        },
        mounted(){
            setTimeout(() => { this.toLogin()}, 3000);
        }
    }
</script>

<style scoped>
    .title-bar {
        position: relative;
        text-align: center;
        margin-top: .36rem;
        margin-bottom: .27rem;
        padding-bottom: .3rem;
        border-bottom: .01rem solid #E6E6E6;
    }

    .title-bar img,
    .title-bar strong {
        vertical-align: middle;
    }

    .title-bar img {
        position: absolute;
        left: .3rem;
        top: 20%;
    }
</style>



// WEBPACK FOOTER //
// src/components/personal/prosperity.vue